import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import SEOHead from '../SEO/SEOHead';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <SEOHead
        title="Privacy Policy | VerveAI"
        description="Privacy policy and data protection practices for VerveAI and Verve AI Labs."
        canonical="https://verveai.co/privacy"
      />
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          Last Updated: October 4, 2025
        </Typography>

        <Box mt={4}>
          <Typography variant="h6" gutterBottom>
            1. Information We Collect
          </Typography>
          <Typography paragraph>
            We collect information that you provide directly to us, such as when you create an account, 
            subscribe to our newsletter, or contact us. This may include your name, email address, 
            and any other information you choose to provide.
          </Typography>

          <Typography variant="h6" gutterBottom>
            2. How We Use Your Information
          </Typography>
          <Typography paragraph>
            We may use the information we collect to:
          </Typography>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Send you technical notices and support messages</li>
            <li>Respond to your comments, questions, and requests</li>
            <li>Send you newsletters and promotional communications</li>
            <li>Monitor and analyze trends, usage, and activities</li>
          </ul>

          <Typography variant="h6" gutterBottom>
            3. Information Sharing
          </Typography>
          <Typography paragraph>
            We do not share your personal information with third parties except as described in this 
            Privacy Policy. We may share information with service providers who perform services on our behalf.
          </Typography>

          <Typography variant="h6" gutterBottom>
            4. Data Security
          </Typography>
          <Typography paragraph>
            We take reasonable measures to help protect your personal information from loss, theft, 
            misuse, and unauthorized access, disclosure, alteration, and destruction.
          </Typography>

          <Typography variant="h6" gutterBottom>
            5. Your Choices
          </Typography>
          <Typography paragraph>
            You may update your account information and email preferences at any time by logging into 
            your account settings page.
          </Typography>

          <Typography variant="h6" gutterBottom>
            6. Contact Us
          </Typography>
          <Typography paragraph>
            If you have any questions about this Privacy Policy, please contact us at 
            <a href="mailto:rds087@gmail.com" style={{ color: '#1976d2', textDecoration: 'none' }}>
              rds087@gmail.com
            </a>.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
